import type { RefCallback, RefObject } from 'react';
import { useCallback, useRef } from 'react';

export function useClosestAncestor<T extends HTMLElement = HTMLElement>(
  selector: string,
): [RefCallback<T>, RefObject<HTMLElement | null>] {
  const elementRef = useRef<T | null>(null);
  const ancestorRef = useRef<HTMLElement | null>(null);

  const callbackRef: RefCallback<T> = useCallback(
    (node) => {
      elementRef.current = node;
      ancestorRef.current = node?.closest(selector) as HTMLElement | null;
    },
    [selector],
  );

  return [callbackRef, ancestorRef];
}
